import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  status$: Observable<boolean> = null;
  private boolSubject: Subject<boolean>;

  constructor() { 
    this.boolSubject = new Subject<boolean>();
    this.status$ = this.boolSubject.asObservable();
  }

  setStatus(status){
    this.boolSubject.next(status)
  }
}
